import { ComponentType, Suspense, useCallback, useEffect, useState } from "react";
import RemoteErrorBoundary from "../error-boundary";
import RemoteFailurePanel from "../remote-failure-panel";

const REMOTE = "art_agentlab";
const EXPOSED_MODULE = "art_agentlab/agent_gateway";

export default function ArtAgentBuilderLoader() {
  const [GatewayComponent, setGatewayComponent] =
    useState<ComponentType | null>(null);
  const [loadError, setLoadError] = useState<unknown>(null);
  const [attempt, setAttempt] = useState(0);

  const retry = useCallback(() => {
    setGatewayComponent(null);
    setLoadError(null);
    setAttempt((current) => current + 1);
  }, []);

  useEffect(() => {
    let active = true;
    async function loadModule() {
      try {
        const module = await import("art_agentlab/agent_gateway");
        if (!module.default) {
          throw new Error(`${EXPOSED_MODULE} did not export a default component`);
        }
        if (active) setGatewayComponent(() => module.default);
      } catch (error) {
        console.error(
          `[module-federation] Failed to load ${EXPOSED_MODULE}`,
          error
        );
        if (active) setLoadError(error);
      }
    }
    loadModule();
    return () => {
      active = false;
    };
  }, [attempt]);

  if (loadError) {
    return (
      <RemoteFailurePanel
        remote={REMOTE}
        exposedModule={EXPOSED_MODULE}
        phase="module"
        error={loadError}
        onRetry={retry}
      />
    );
  }
  if (!GatewayComponent) return <div>Loading Agent Lab…</div>;

  return (
    <Suspense fallback={<div>Loading Agent Lab…</div>}>
      <RemoteErrorBoundary
        key={attempt}
        remote={REMOTE}
        exposedModule={EXPOSED_MODULE}
        onRetry={retry}
      >
        <GatewayComponent />
      </RemoteErrorBoundary>
    </Suspense>
  );
}
